import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { NovaMetadata } from '../models/pendo/nova-metadata.model';
import { PendoEventBase } from 'src/app/shared/models/pendo/pendo-base';
import { combine } from '../utilities/route';

// A variable named pendo is created when the pendo script in index.html loads in
declare let pendo: any;

@Injectable({
    providedIn: 'root'
})
export class PendoService {
    private initializedUser: string;
    private initialized = false;
    private readonly pendoApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.pendoApiPath = combine(settings.coreAPIUrl, 'pendo');
    }

    init() {
        this.getPendoMetadata()
            .pipe(take(1))
            .subscribe((metadata: NovaMetadata) => {                
                if (!this.initialized) {
                    pendo.initialize({
                        visitor: {
                            ...metadata
                        }
                    });

                    this.initializedUser = metadata.id;
                    this.initialized = true;
                } else if (this.initializedUser !== metadata.id) {
                    // Don't go through full initialization if the user changes, just update the user
                    pendo.identify({
                        visitor: {
                            ...metadata
                        }
                    });
                    this.initializedUser = metadata.id;
                }
            });
    }

    getPendoMetadata(): Observable<NovaMetadata> {
        const url = combine(`${this.pendoApiPath}/NovaMetadata`);
        return this.http.get<NovaMetadata>(url);
    }

    trackEvent(event: PendoEventBase) {
        pendo.track(event.name, event.metadata);
    }
}
